import { render, staticRenderFns } from "./CompaniesAudit.vue?vue&type=template&id=06ec0364&scoped=true&"
import script from "./CompaniesAudit.vue?vue&type=script&lang=js&"
export * from "./CompaniesAudit.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesAudit.vue?vue&type=style&index=0&id=06ec0364&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ec0364",
  null
  
)

export default component.exports